import React, { useEffect, useState } from 'react'
import { Logo } from '../logo'
import Link from '../link'
import Button from '../button'
import { IconDarkTheme, IconLightTheme } from '../icons'
import { getStoreItem, saveStoreItem } from '../../utils'
import { themeKey } from '../../utils/exports/Keys'
import { LogoOnly } from '../logo/Logo'

function Header() {
    const theme = getStoreItem(themeKey) || "dark";
    const [isDarkTheme, setIsDarkTheme] = useState<boolean>(true)
    const d = (id: string) => {
        const d = document.getElementById(id);
        if (d) d.scrollIntoView({ behavior: "smooth" })
    }
    const toggleTheme = () => {
        const body = document.body;
        if (isDarkTheme) {
            setIsDarkTheme(false);
            saveStoreItem(themeKey, 'light')
            body.setAttribute("class", "light")
            return
        }
        setIsDarkTheme(true);
        saveStoreItem(themeKey, 'dark')
        body.setAttribute("class", "dark")
    }

    useEffect(() => {
        setIsDarkTheme(theme === "dark")
    }, [theme])


    return (
        <div className='header'>
            <div className='hd-bucket'>
                <div className='hd-left'>
                    <a href='/'>
                        <span className='mobile-link'><Logo size={70} showGraphic={true} /></span>
                        <span className='mobile-only'><LogoOnly /></span>
                    </a>
                    <Button onClick={toggleTheme} style={{ marginLeft: 12 }} icon={isDarkTheme ? <IconLightTheme /> : <IconDarkTheme />} />
                </div>
                <div className='center hd-right'>
                    <div className='center hd-links'>
                        <Link className='mobile-link' activeClassName='link-active' text='Home' url='/' />
                        <Link className='mobile-link' exact onClick={() => d('services')} url='/#services' text='Services' />
                        <Link className='mobile-link' onClick={() => d('contact')} url='/#contact' text='Contact us' />
                        <Button onClick={() => window.open('/book', '_self')} style={{ marginLeft: 12 }} type='solid' text='Book appointment' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header